// extracted by mini-css-extract-plugin
export default {"infoCircle":"InfoCircle_infoCircle__OdIb3"};